function loadGoogleMaps(apiKey) {
    if (window.google && window.google.maps && window.google.maps.importLibrary) {
        return Promise.resolve(window.google.maps);
    }

    if (window.armodonnaGoogleMapsPromise) {
        return window.armodonnaGoogleMapsPromise;
    }

    window.armodonnaGoogleMapsPromise = new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = "https://maps.googleapis.com/maps/api/js?"
            + new URLSearchParams({
                key: apiKey,
                loading: "async",
                libraries: "places",
                language: "it",
                region: "IT",
            }).toString();
        script.async = true;
        script.onload = () => resolve(window.google.maps);
        script.onerror = () => reject(
            new Error("Unable to load Google Maps JavaScript API")
        );
        document.head.appendChild(script);
    });

    return window.armodonnaGoogleMapsPromise;
}

function setValue(id, value) {
    const field = document.getElementById(id);
    if (!field) {
        return;
    }

    field.value = value || "";
    field.dispatchEvent(new Event("change", { bubbles: true }));
}

function setAddressSelected(selected) {
    const field = document.getElementById("id_google_address_selected");
    if (field) {
        field.value = selected ? "1" : "0";
    }
}

function setAddressEntryMode(mode) {
    const field = document.getElementById("id_address_entry_mode");
    if (field) {
        field.value = mode;
    }
}

function setAddressDisplay(value) {
    const field = document.getElementById("id_google_address_display");
    if (field) {
        field.value = value || "";
    }
}

function showSearchMode(show) {
    const searchMode = document.getElementById("arm-google-address-search-mode");
    if (!searchMode) {
        return;
    }
    searchMode.classList.toggle("d-none", !show);
    if (show) {
        searchMode.style.removeProperty("display");
    } else {
        searchMode.style.setProperty("display", "none", "important");
    }
}

function showSelectedSummary(show, text = "") {
    const summary = document.getElementById("arm-google-address-selected-summary");
    const summaryText = document.getElementById("arm-google-address-selected-text");
    if (!summary) {
        return;
    }

    if (summaryText && text) {
        summaryText.textContent = text;
    }

    summary.classList.toggle("d-none", !show);
    if (show) {
        summary.style.removeProperty("display");
    } else {
        summary.style.setProperty("display", "none", "important");
    }
}

function showAddressFields(show) {
    const fields = document.getElementById("arm-google-address-fields");
    if (!fields) {
        return;
    }

    fields.hidden = !show;
    fields.classList.toggle("d-none", !show);

    if (show) {
        fields.style.removeProperty("display");
    } else {
        fields.style.setProperty("display", "none", "important");
    }
}

function setAddressFieldsReadonly(readonly) {
    [
        "id_line1",
        "id_line2",
        "id_line4",
        "id_state",
        "id_postcode",
    ].forEach((id) => {
        const field = document.getElementById(id);
        if (field) {
            field.readOnly = readonly;
        }
    });
}

function resetConfirmation() {
    const field = document.getElementById("id_google_address_confirmed");
    if (field) {
        field.value = "0";
    }
}

function componentValue(components, type, shortName = false) {
    const component = components.find(
        (item) => item.types && item.types.includes(type)
    );

    if (!component) {
        return "";
    }

    return shortName
        ? (component.shortText || component.longText || "")
        : (component.longText || component.shortText || "");
}

async function initShippingAddressAutocomplete() {
    const container = document.getElementById("arm-google-address-search");
    if (!container || container.dataset.initialized === "1") {
        return;
    }

    const apiKey = container.dataset.googleMapsApiKey;
    if (!apiKey) {
        return;
    }

    container.dataset.initialized = "1";

    // Search is the only primary path. Address fields are revealed only
    // after an explicit Google selection or an explicit manual-entry choice.
    const initialMode = document.getElementById("id_address_entry_mode")?.value || "search";
    const initialDisplay = document.getElementById("id_google_address_display")?.value || "";

    if (initialMode === "manual") {
        setAddressSelected(false);
        setAddressFieldsReadonly(false);
        showSearchMode(false);
        showSelectedSummary(false);
        showAddressFields(true);
    } else if (initialMode === "google" && initialDisplay) {
        setAddressSelected(true);
        setAddressFieldsReadonly(true);
        showSearchMode(false);
        showSelectedSummary(true, initialDisplay);
        showAddressFields(false);
    } else {
        setAddressSelected(false);
        setAddressEntryMode("search");
        setAddressFieldsReadonly(false);
        showSearchMode(true);
        showSelectedSummary(false);
        showAddressFields(false);
    }

    try {
        const maps = await loadGoogleMaps(apiKey);
        const places = await maps.importLibrary("places");

        const autocomplete = new places.PlaceAutocompleteElement({
            includedRegionCodes: ["it"],
            requestedLanguage: "it",
            requestedRegion: "it",
        });

        container.appendChild(autocomplete);

        autocomplete.addEventListener("gmp-select", async (event) => {
            const place = event.placePrediction.toPlace();
            await place.fetchFields({
                fields: ["addressComponents", "formattedAddress"],
            });

            const components = place.addressComponents || [];
            const route = componentValue(components, "route");
            const streetNumber = componentValue(
                components,
                "street_number"
            );
            const locality = (
                componentValue(components, "locality")
                || componentValue(
                    components,
                    "administrative_area_level_3"
                )
            );
            const province = componentValue(
                components,
                "administrative_area_level_2",
                true
            );
            const postcode = componentValue(
                components,
                "postal_code"
            );

            setValue("id_line1", route);
            setValue("id_line2", streetNumber);
            setValue("id_line4", locality);
            setValue("id_state", province);
            setValue("id_postcode", postcode);
            const displayAddress = place.formattedAddress || [
                route,
                streetNumber,
                postcode,
                locality,
                province,
            ].filter(Boolean).join(" ");

            resetConfirmation();
            setAddressSelected(true);
            setAddressEntryMode("google");
            setAddressDisplay(displayAddress);
            setAddressFieldsReadonly(true);
            showSearchMode(false);
            showSelectedSummary(true, displayAddress);
            showAddressFields(false);
        });

        const changeButton = document.getElementById(
            "arm-google-address-change"
        );
        if (changeButton) {
            changeButton.addEventListener("click", () => {
                ["id_line1", "id_line2", "id_line4", "id_state", "id_postcode"]
                    .forEach((id) => setValue(id, ""));
                resetConfirmation();
                setAddressSelected(false);
                setAddressEntryMode("search");
                setAddressDisplay("");
                setAddressFieldsReadonly(false);
                showSelectedSummary(false);
                showAddressFields(false);
                showSearchMode(true);
                autocomplete.focus();
            });
        }

        const manualBackButton = document.getElementById(
            "arm-manual-address-back"
        );
        if (manualBackButton) {
            manualBackButton.addEventListener("click", () => {
                ["id_line1", "id_line2", "id_line4", "id_state", "id_postcode"]
                    .forEach((id) => setValue(id, ""));
                resetConfirmation();
                setAddressSelected(false);
                setAddressEntryMode("search");
                setAddressDisplay("");
                setAddressFieldsReadonly(false);
                showAddressFields(false);
                showSelectedSummary(false);
                showSearchMode(true);
                autocomplete.focus();
            });
        }

        const manualButton = document.getElementById(
            "arm-manual-address-entry"
        );
        if (manualButton) {
            manualButton.addEventListener("click", () => {
                resetConfirmation();
                setAddressSelected(false);
                setAddressEntryMode("manual");
                setAddressDisplay("");
                setAddressFieldsReadonly(false);
                showSearchMode(false);
                showSelectedSummary(false);
                showAddressFields(true);
            });
        }

        [
            "id_line1",
            "id_line2",
            "id_line4",
            "id_state",
            "id_postcode",
        ].forEach((id) => {
            const field = document.getElementById(id);
            if (field) {
                field.addEventListener("input", resetConfirmation);
            }
        });
    } catch (error) {
        container.dataset.initialized = "0";
        setAddressSelected(false);
        setAddressEntryMode("search");
        setAddressDisplay("");
        setAddressFieldsReadonly(false);
        showSelectedSummary(false);
        showAddressFields(false);
        showSearchMode(true);
        console.error(
            "Shipping address autocomplete initialization failed:",
            error
        );
    }
}

document.addEventListener(
    "DOMContentLoaded",
    initShippingAddressAutocomplete
);

if (document.readyState !== "loading") {
    initShippingAddressAutocomplete();
}
